import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackPlaylistScoreChartParams {
  trackId: string;
  date?: Date;
  rangeDays?: number;
}

export const useTrackPlaylistScoreChart = ({ trackId, date, rangeDays }: UseTrackPlaylistScoreChartParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const playlistScoreChartQuery = useTRPCQuery(
    trpcMusicAPI.tracks.playlistScoreChart.queryOptions(
      {
        trackId,
        date,
        rangeDays,
        ...shareTokenInput,
      },
      {
        enabled: Boolean(trackId),
      }
    )
  );

  return playlistScoreChartQuery;
};
